import { render } from "./CreateGoalsModal.vue?vue&type=template&id=29f77dd6"
import script from "./CreateGoalsModal.vue?vue&type=script&lang=js"
export * from "./CreateGoalsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__